interface AreaWithResidentDetails {
  residentDetailsFi: string | null
  residentDetailsSv: string | null
  residentDetailsEn: string | null
}

export const pickResidentDetails = (
  area: AreaWithResidentDetails,
  lang: string
): string | null => {
  switch (lang) {
    case 'fi':
      return area.residentDetailsFi
    case 'sv':
      return area.residentDetailsSv
    case 'en':
      return area.residentDetailsEn
    default:
      return area.residentDetailsFi
  }
}
